import { EDITOR_TEXT_BOX_SEED_HEIGHT_PX } from '@/utils/editor-text-box/editorTextBoxAdapter'

export type TextBoxSeedFrameInput = {
  /**
   * The frame the item holds — the row's, or the author's after a handle
   * release or a size typed in. Null when the surface holds no item frame.
   */
  itemHeightPx: number | null
  /** The frame the page paints, which is the frame the seed raises. */
  liveHeightPx: number
  /** The text's own height as the fit read it; null when nothing was measured. */
  textHeightPx: number | null
}

/**
 * The height a fresh box's first paint raises its frame to, or null when
 * the frame is nobody's seed. A fresh box is drawn at the seed height,
 * shorter than its one line of text, and its first paint raises the frame
 * to the text instead of writing the text smaller, so entering it changes
 * nothing. Only a frame no taller than the seed is a seed's, and the caller
 * asks only for a box this session inserted (`editorTextBoxSeedIdsAtom`): a
 * saved row opens at its saved frame however short, and a box a person
 * shrank below its text is theirs and stays.
 */
export const textBoxSeedFrameHeightPx = ({
  itemHeightPx,
  liveHeightPx,
  textHeightPx,
}: TextBoxSeedFrameInput): number | null => {
  if (textHeightPx === null || !Number.isFinite(textHeightPx)) return null
  const judged = itemHeightPx ?? liveHeightPx
  if (judged > EDITOR_TEXT_BOX_SEED_HEIGHT_PX) return null
  const next = Math.ceil(textHeightPx - 1e-6)
  return next > liveHeightPx ? next : null
}
